// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staking_page_wrapper {
    width: 100%;
    padding: 60px 0px;
    color: #fff;
}


body .text-black {
    color: #d3d3d3 !important;
}

body.light_theme .text-black {
    color: #111 !important;
}

body.light_theme .staking_page_wrapper {
    color: #1a1a1a;
}

.staking_page_wrapper .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
}

.staking_bnr_cnt {
    justify-content: space-between;
    align-items: center;
    gap: 32px;
    margin-bottom: 60px;
}

.staking_title {
    font-size: 48px;
    font-weight: 700;
    margin: 0;
}


.staking_page_wrapper .convert-page__faqSection {
    padding: 0px 0px 50px;
}

.staking_page_wrapper p.staking_desc {
    font-size: 18px;
    color: #84888C;
    font-weight: 500;
    margin-top: 15px;
}

.staking_page_wrapper .staking_btn {
    padding-top: 15px;
}

.staking_page_wrapper .staking_btn button {
    font-size: 15px;
    color: #070808;
    background-color: #F5F6F7;
    border-radius: 50px;
    padding: 16px 24px;
    font-weight: 500;
    border: none;
    cursor: pointer;
}

.staking_page_wrapper .staking_btn button.loginbtn {
    background-color: #303236;
    color: #fff;
}

.staking_img {
    max-width: 450px;
}

.staking_info_section {
    margin: 100px 0px 70px;
}

.staking_info_title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 32px;
    color: #fff;
}

body.light_theme .staking_info_title {
    color: #070808;
}

.staking_info_cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding-top: 25px;
}

.staking_info_card {
    display: flex;
    flex-direction: column;
    position: relative;
    padding-left: 85px;
}

.staking_info_icon {
    width: 80px;
    height: 80px;
    border: 1px solid #EFDEC2;
    margin-bottom: 24px;
    border-radius: 50%;
    box-shadow: 0px 1px 10px #0000001c;
    display: flex;
    align-items: center;
    justify-content: center;
}

.staking_info_card .number {
    font-size: 60px;
    color: #F3EBDF;
    font-weight: 700;
    position: absolute;
    left: 0px;
}

.staking_info_icon img {
    object-fit: contain;
}

.staking_info_card h3 {
    font-size: 20px;
    font-weight: 600;
    color: #dddddd;
    margin: 0 0 12px 0;
}

body.light_theme .staking_info_card h3 {
    color: #111;
}

.staking_info_card p {
    font-size: 16px;
    color: #84888C;
    line-height: 1.5;
    margin: 0;
}

.nextarrow_step {
    font-size: 36px;
    color: #E5E7EB;
    position: absolute;
    right: -20px;
    font-weight: 200;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    z-index: 10;
}

.staking_products_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.staking_products_header h2 {
    font-size: 28px;
    font-weight: 700;
    margin: 0;
    color: #fff;
}

body.light_theme .staking_products_header h2 {
    color: #111;
}

.staking_products_filters {
    display: flex;
    align-items: center;
    gap: 24px;
}

.staking_checkbox_label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
}

body.staking_checkbox_label {
    color: #070808;
}

.staking_checkbox_label input {
    width: 16px;
    height: 16px;
    accent-color: #333;
    cursor: pointer;
}

.staking_search_bar {
    display: flex;
    align-items: center;
    background-color: #f6f6f708;
    border-radius: 6px;
    padding: 8px 16px;
    gap: 10px;
    width: 240px;
}

body.light_theme .staking_search_bar {
    background-color: #F6F6F7;
}

.staking_search_bar input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 14px;
    width: 100%;
    color: #e4e4e4;
}

body.light_theme .staking_search_bar input {
    color: #111;
}

.staking_search_bar input::placeholder {
    color: #a0a5aa;
}

.staking_table_container {
    width: 100%;
    overflow-x: auto;
}

.staking_table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
}

.staking_table th {
    padding: 16px;
    color: #848e9c;
    font-size: 12px;
    font-weight: 400;
}

.staking_table th .sort_icon {
    font-size: 10px;
    margin-left: 4px;
    color: #a0a5aa;
}

.staking_table td {
    padding: 24px 16px;
    /* border-bottom: 1px solid #f5f6f7; */
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}

body.light_theme .staking_table td {
    color: #1e2329;
}

.staking_table .action_th,
.staking_table .action_td {
    text-align: right;
    width: auto;
    float: right;
}

.coin_cell {
    display: flex;
    align-items: center;
    gap: 8px;
}

.coin_icon_stak {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 14px;
}

.staking_page_wrapper .coin_name {
    font-weight: 500;
    color: #fff;
    font-size: 16px;
}

body.light_theme .staking_page_wrapper .coin_name {
    color: #070808;
}

.staking_page_wrapper .coin_badge {
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
}

.badge_bonus {
    background-color: #8FFCDE;
    color: #000000;
}

.badge_vip {
    background-color: #FFD98F;
    color: #000000;
}

.badge_new {
    background-color: #52FFB1;
    color: #000000;
}

.fire_icon {
    font-size: 14px;
}

.apr_cell {
    font-weight: 600;
    color: #1e2329;
}

.reward_icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    font-size: 10px;
}

.multiple_rewards {
    display: flex;
    align-items: center;
}

.multiple_rewards .reward_icon {
    margin-left: -8px;
    border: 2px solid white;
}

.multiple_rewards .reward_icon:first-child {
    margin-left: 0;
}

.type_cell {
    font-weight: 600;
    color: #4b4f56;
}

.action_btn {
    background-color: #2b3139;
    color: white;
    border: none;
    padding: 8px 24px;
    border-radius: 20px;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.action_btn:hover {
    background-color: #1e2329;
}

.mobile_action_btns {
    display: none;
}

.staking_pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    gap: 8px;
}

.page_num,
.page_nav {
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #4b4f56;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
}

.page_num:hover,
.page_nav:hover {
    background-color: #f5f6f7;
}

.page_num.active {
    background-color: #f5f6f7;
    color: #111;
}

/* Why Stake Section */
.why_stake_section_new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 100px 0px;
}

.why_stake_left {
    flex: 1 1;
}

.why_stake_right {
    flex: 1 1;
    display: flex;
    justify-content: end;
    align-items: center;
}

.why_stake_right img {
    max-width: 240px;
}

.why_stake_cards {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 30px;
}

.why_stake_card {
    display: flex;
    align-items: center;
    background-color: #fafafa0a;
    border: 1px solid #f3f4f60d;
    padding: 30px;
    position: relative;
    border-radius: 14px;
}

body.light_theme .why_stake_card {
    background-color: #fafafa;
    border: 1px solid #F3F4F6;
}

.why_stake_card::before {
    content: "";
    width: 3px;
    height: 30px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0px;
    left: 0;
    background-color: #C59D5F;
    border-radius: 2px;
    z-index: 999;
}

.why_stake_card_icon {
    width: 50px;
    height: 50px;
    border: 1px solid #F3F4F6;
    min-width: 50px;
    background-color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.why_stake_card_icon img {
    width: 28px;
    height: 28px;
    object-fit: contain;
}

.why_stake_card_content h3 {
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 5px 0;
}

.why_stake_card_content p {
    font-size: 13px;
    color: #84888C;
    margin: 0;
}

/* How to Stake Section */
.how_stake_section {
    margin-bottom: 100px;
}

.how_stake_timeline {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 60px;
    gap: 32px;
}

.timeline_line {
    position: absolute;
    top: 40px;
    left: 10%;
    right: 10%;
    height: 1px;
    border-top: 1px dashed #eaecef;
    background-color: transparent;
    z-index: 1;
}

.timeline_step {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    z-index: 2;
}

.step_icon_container {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
}

.step_icon {
    width: 94px;
    border: 1px solid #c4c6cf42;
    height: 94px;
    background-color: #171a20;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

body.light_theme .step_icon {
    background-color: white;
}

.step_icon img {
    width: 32px;
    height: 32px;
    object-fit: contain;
    filter: invert(1);
}

body.light_theme .step_icon img {
    filter: invert(0);
}

.step_number {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #171a20;
    color: #e0e0e0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    position: absolute;
    top: -8px;
    border: 1px solid #C4C6CF30;
}

body.light_theme .step_number {
    background-color: #F7F9FB;
    color: #292b2f;
}

.timeline_step h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 12px 0;
}

.timeline_step p {
    font-size: 13px;
    color: #84888C;
    margin: 0;
    max-width: 370px;
}


@media (max-width: 1366px) {

    .staking_title {
        font-size: 38px;
    }


}


@media (max-width: 1200px) {

    .staking_title {
        font-size: 32px;
    }

    .staking_img {
        max-width: 300px;
    }


    .staking_page_wrapper .staking_btn button {
        font-size: 14px;
        padding: 10px 20px;
    }

    .why_stake_card_content h3 {
        font-size: 18px;
    }

    .staking_info_title {
        font-size: 24px;
    }

}

@media (max-width: 991px) {

    .staking_info_card .number {
        font-size: 40px;
    }

    .staking_info_card {
        padding-left: 65px;
    }

    .staking_info_card h3 {
        font-size: 18px;
    }

    .staking_info_card p {
        font-size: 14px;
    }

}



/* Mobile Table and Popup styles */
@media (max-width: 767px) {

    .staking_table th:nth-child(3),
    .staking_table th:nth-child(4),
    .staking_table th:nth-child(5),
    .staking_table td:nth-child(3),
    .staking_table td:nth-child(4),
    .staking_table td:nth-child(5) {
        display: none;
    }

    .why_stake_section_new {
        margin: 40px 0px;
    }

    .staking_table th:nth-child(2),
    .staking_table td:nth-child(2) {
        text-align: right;
    }

    .staking_table th:nth-child(1),
    .staking_table td:nth-child(1) {
        padding-left: 10px;
    }

    .staking_table tbody tr {
        cursor: pointer;
    }

    .mobile_staking_popup_overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        display: flex;
        align-items: flex-end;
    }

    .mobile_staking_popup {
        background: #fff;
        width: 100%;
        border-radius: 20px 20px 0 0;
        padding: 24px;
        animation: slideUp 0.3s ease;
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    .mobile_staking_popup .popup_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .mobile_staking_popup .popup_header h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
    }

    .mobile_staking_popup .close_btn {
        background: none;
        border: none;
        font-size: 28px;
        color: #84888C;
        cursor: pointer;
    }

    .mobile_staking_popup .popup_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
        font-size: 15px;
    }

    .mobile_staking_popup .popup_row:last-child {
        border-bottom: none;
    }

    .mobile_staking_popup .popup_row span:first-child {
        color: #84888C;
    }

    .mobile_staking_popup .apr_val {
        color: #111;
        font-weight: 600;
    }

    .reward_popup_icons {
        display: flex;
        gap: 6px;
    }

    .reward_popup_icon {
        width: 24px;
        height: 24px;
    }

    .mobile_staking_popup .popup_footer {
        margin-top: 18px;
    }

    .mobile_staking_popup .popup_footer .action_btn {
        font-size: 13px;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        padding: 8px !important;
    }

    .mobile_action_btns {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
    }
}

@media (max-width: 660px) {

    .staking_bnr_cnt {
        flex-direction: column;
        gap: 32px;
        margin-bottom: 40px;
        text-align: center;
    }

    .staking_info_card .number {
        display: none;
    }

    .staking_title {
        font-size: 24px;
    }

    .staking_table td {
        padding: 15px 10px;
        font-size: 14px;
    }

    .staking_page_wrapper .coin_name {
        font-size: 14px;
    }

    .staking_pagination {
        margin-top: 20px;
    }

    .staking_page_wrapper p.staking_desc {
        font-size: 15px;
        margin-top: 10px;
    }

    .staking_img {
        max-width: 240px;
    }


    .staking_page_wrapper {
        padding: 50px 0px;
    }

    .staking_page_wrapper .staking_btn {
        padding-top: 0px;
        justify-content: center;
    }

    .staking_products_header h2 {
        font-size: 20px;
    }

    .staking_products_header {
        align-items: start;
        margin-bottom: 20px;
        gap: 20px;
    }

    .staking_info_cards {
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }

    .staking_info_title {
        font-size: 20px;
        margin-bottom: 0px;
        text-align: center;
    }

    .why_stake_section_new {
        flex-direction: column;
        margin-bottom: 50px;
    }

    .why_stake_right {
        margin-top: 32px;
    }

    .why_stake_card_content h3 {
        font-size: 16px;
    }

    .timeline_step {
        display: grid;
        grid-template-columns: 60px 1fr;
        column-gap: 16px;
        row-gap: 6px;
        text-align: left;
    }

    .step_icon_container {
        grid-column: 1;
        grid-row: 1 / span 2;
        margin: 0;
        z-index: 2;
    }

    .step_icon {
        width: 50px;
        height: 50px;
    }

    .step_icon img {
        width: 24px;
        height: 24px;
    }

    .step_number {
        width: 20px;
        height: 20px;
        font-size: 10px;
        top: -6px;
    }

    .timeline_step h3 {
        font-size: 16px;
        margin: 0px;
        align-self: end;
    }

    .timeline_step p {
        max-width: 100%;
        font-size: 13px;
        align-self: start;
        margin: 0;
    }

    .how_stake_section {
        margin-bottom: 40px;
    }

    .how_stake_timeline {
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin-top: 30px;
        position: relative;
    }

    .timeline_line {
        top: 20px;
        bottom: 30px;
        left: 25px;
        width: 1px;
        height: auto;
        right: auto;
        border-top: none;
        border-left: 1px dashed #eaecef;
        background-color: transparent;
    }

    .staking_info_section {
        margin: 40px 0px 40px;
        text-align: center;
    }

    .staking_info_card h3 {
        font-size: 16px;
        margin-top: 15px;
    }

    .staking_info_icon {
        width: 54px;
        height: 54px;
        margin: 0 auto;
    }

    .staking_info_card {
        border-radius: 0px;
        padding: 0px;
    }

    .staking_info_card p {
        font-size: 13px;
    }

    .nextarrow_step {
        display: none;
    }

}

/* Staking Detail / Help Center Layout */
.staking_detail_wrapper {
    width: 100%;
    padding: 40px 0;
    color: #e5e5e5;
    background-color: #171a20;
    min-height: 80vh;
}

body.light_theme .staking_detail_wrapper {
    background-color: #fff;
    color: #111;
}

.staking_detail_wrapper .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
}

.hc_breadcrumb {
    font-size: 16px;
    color: #A0A3A7;
    margin-bottom: 40px;
}

.hc_breadcrumb .hc_link {
    cursor: pointer;
}

.hc_breadcrumb .hc_link:hover {
    opacity: 0.8;
}

body.light_theme .hc_breadcrumb .hc_link:hover {
    color: #111;
}

.hc_breadcrumb .hc_sep {
    margin: 0 8px;
    font-size: 12px;
}

.hc_breadcrumb .hc_current {
    color: #dadada;
    font-weight: 500;
}

body.light_theme .hc_breadcrumb .hc_current {
    color: #111;
}

.hc_layout {
    display: flex;
    gap: 40px;
}

.hc_sidebar {
    width: 260px;
    flex-shrink: 0;
    border-bottom: none;
    padding-right: 40px;
}


.hc_mobile_toggle {
    display: none;
}

.hc_sidebar_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 0;
    font-size: 16px;
    color: #dadada;
    cursor: pointer;
    border-bottom: 1px solid transparent;

}

body.light_theme .hc_sidebar_item {
    color: #484B51;
}

.hc_sidebar_item:hover {
    color: #dedede;
}

body.light_theme .hc_sidebar_item:hover {
    color: #111;
}

.hc_sidebar_item .font-weight-bold {
    font-weight: 600;
}

.hc_sidebar_item .text-black {
    color: #111;
}


.hc_chev {
    color: #848e9c;
    transition: transform 0.2s ease;
    transform: rotate(0deg);
}

.hc_chev.open {
    transform: rotate(90deg);
}

.hc_submenu {
    padding-left: 20px;
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.hc_submenu_item {
    font-size: 16px;
    color: #d6d6d6;
    cursor: pointer;
    transition: color 0.2s;
}

body.light_theme .hc_submenu_item {
    color: #484B51;
}

.hc_submenu_item:hover {
    color: #e0e0e0;
}

body.light_theme .hc_submenu_item:hover {
    color: #111;
}

.hc_submenu_item.active_sub {
    font-weight: 600;
    color: #dfdfdf;
}

body.light_theme .hc_submenu_item.active_sub {
    color: #111;
}

.hc_main_content {
    flex-grow: 1;
}

.hc_content_section {
    margin-bottom: 18px;
}

.hc_section_header {
    display: flex;
    gap: 24px;
    align-items: center;
    padding-bottom: 16px;
    cursor: pointer;
}

.hc_section_header h2 {
    font-size: 19px;
    font-weight: 600;
    margin: 0;
    color: #dedede;
}

body.light_theme .hc_section_header h2 {
    color: #111;
}

.hc_section_chev {
    color: #dedede;
    transition: transform 0.2s ease;
    transform: rotate(90deg);
}

body.light_theme .hc_section_chev {
    color: #111;
}

.hc_section_chev.open {
    transform: rotate(-90deg);
}

.hc_article_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 40px;
    padding-bottom: 24px;
}

.hc_article_item {
    font-size: 16px;
    line-height: 1.5;
}

.hc_article_item a {
    color: #c1c1c1;
    text-decoration: none;
    transition: color 0.2s;
}

body.light_theme .hc_article_item a {
    color: #4b4f56;
}

.hc_article_item a:hover {
    color: #c1c1c1;
}

body.light_theme .hc_article_item a:hover {
    color: #111;
}

@media (max-width: 767px) {
    .hc_layout {
        flex-direction: column;
        gap: 30px;
    }

    .hc_mobile_toggle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        margin-bottom: 0px;
        cursor: pointer;
    }

    .hc_mobile_toggle h2 {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: #111;
    }

    .hc_section_header h2 {
        font-size: 16px;
    }

    .hc_article_item {
        font-size: 14px;
    }

    .hc_sidebar {
        display: none;
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #eaecef;
        padding-right: 0;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }

    .hc_sidebar.mobile_open {
        display: block;
    }

    .hc_article_grid {
        grid-template-columns: 1fr;
    }
}

/* Mint Modal styling */
.mint-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    height: 100vh;
    background-color: rgb(255 255 255 / 20%) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999;
    animation: fadeInModal 0.25s ease-out;
}

.mint-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
    width: 95%;
    max-width: 800px;
    border-radius: 12px;
    padding: 24px 32px;
    position: relative;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

.mint-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.mint-modal-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
    font-weight: 700;
}

.mint-title-icon {
    width: 24px;
    height: 24px;
}

.mint-modal-close {
    background: transparent;
    border: none;
    font-size: 24px;
    color: #848e9c !important;
    cursor: pointer;
    transition: color 0.2s;
    line-height: 1;
}

.mint-modal-close:hover {
    color: #1e2329 !important;
}

.mint-modal-body {
    display: flex;
    gap: 40px;
}

/* Left Column */
.mint-modal-left {
    flex: 1 1;
}

.mint-info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
}

.mint-info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.mint-info-label {
    font-size: 13px;
    color: #848e9c !important;
    font-weight: 500;
}

.mint-info-value {
    font-size: 16px;
    font-weight: 600;
    color: #1e2329 !important;
}

.mint-green-text {
    color: #03a66d !important;
}

.mint-section-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
}

.mint-input-box {
    display: flex;
    align-items: center;
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 10px 16px;
    transition: border-color 0.2s;
}

.mint-input-box:focus-within {
    border-color: #1a1d21;
}

.mint-input-box input {
    flex: 1 1;
    border: none;
    background: none;
    outline: none;
    font-size: 14px;
    color: #1e2329 !important;
}

.mint-input-addon {
    display: flex;
    align-items: center;
    gap: 12px;
}

.mint-max-btn {
    color: #d1aa67 !important;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
}

.mint-currency-dropdown {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.mint-amount-details {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 32px;
}

.mint-amount-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.mint-amount-lbl {
    color: #848e9c !important;
}

.mint-amount-lbl--inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.mint-amount-info-tooltip {
    border-bottom: none;
    cursor: help;
    color: #848e9c;
    font-size: 14px;
    line-height: 1;
}

.mint-amount-info-tooltip .mint-tooltip {
    width: 220px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
}

.mint-amount-info-tooltip .mint-tooltip::after {
    left: 50%;
    transform: translateX(-50%);
}

.mint-amount-val {
    color: #1e2329 !important;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
}

.mint-add-icon {
    font-size: 14px;
    cursor: pointer;
}

.mint-apr-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    color: #848e9c !important;
}

.mint-apr-box span:last-child {
    font-weight: 600;
    color: #1e2329 !important;
}

/* Right Column */
.mint-modal-right {
    flex: 1 1;
}

.mint-daily-return-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 8px;
}

.mint-daily-return-box {
    border: 1px solid #eaecef;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 32px;
}

.mint-return-icon {
    width: 20px;
    height: 20px;
}

.mint-return-val {
    font-size: 14px;
    font-weight: 600;
    color: #12a771 !important;
}

.mint-rules-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-bottom: 1px solid #eaecef;
    padding-bottom: 8px;
}

.mint-rules-title {
    font-size: 14px;
    font-weight: 600;
    position: relative;
}

.mint-title-underline {
    position: absolute;
    bottom: -9px;
    left: 0;
    width: 20px;
    height: 3px;
    background-color: #1e2329;
    border-radius: 2px;
}

.mint-rules-link {
    font-size: 13px;
    color: #848e9c !important;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.mint-timeline {
    position: relative;
    padding-left: 12px;
}

.mint-timeline::before {
    content: '';
    position: absolute;
    top: 6px;
    bottom: 20px;
    left: 14px;
    width: 1px;
    background-color: #eaecef;
}

.mint-timeline-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    position: relative;
}

.mint-timeline-item.last {
    margin-bottom: 0;
}

.mint-timeline-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #eaecef;
    margin-top: 6px;
    margin-right: 16px;
    position: relative;
    z-index: 2;
}

.mint-timeline-dot.active {
    background-color: #1e2329;
}

.mint-timeline-dot.icon {
    background-color: transparent;
    margin-top: 2px;
    margin-left: -3px;
    font-size: 14px;
    color: #848e9c;
}

.mint-timeline-content {
    flex: 1 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 13px;
}

.mint-timeline-lbl {
    color: #1e2329 !important;
}

.mint-timeline-val {
    color: #848e9c !important;
    text-align: right;
}

.mint-timeline-val.multi-line {
    line-height: 1.4;
}

.redeem-modal-content {
    max-width: 480px;
    padding: 24px;
}

.redeem-modal-body {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.redeem-modal-timeline {
    margin-top: 4px;
}

.redeem-modal-footer {
    margin-top: 24px;
    justify-content: flex-end;
}

.redeem-modal-footer .mint-actions {
    margin-left: auto;
}

/* Footer */
.mint-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
}

.mint-agreement {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
}

.mint-agreement input {
    cursor: pointer;
}

.mint-agreement label {
    color: #1e2329 !important;
}

.mint-agreement a {
    color: #1e2329 !important;
    text-decoration: underline;
}

.mint-actions {
    display: flex;
    gap: 12px;
}

.mint-btn-cancel {
    background-color: #f5f6f7;
    color: #1e2329 !important;
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
}

.mint-btn-confirm {
    background-color: #f5f6f7;
    color: #b7bdc6 !important;
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    cursor: not-allowed;
    font-size: 14px;
}

.mint-btn-confirm:not(:disabled) {
    background: #1a1d21;
    color: #fff;
    cursor: pointer;
}

@media (max-width: 767px) {
    .mint-modal-body {
        flex-direction: column;
        gap: 24px;
    }

    .mint-modal-footer {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;
    }

    .mint-actions {
        flex-direction: column;
    }

    .mint-btn-cancel,
    .mint-btn-confirm {
        width: 100%;
    }

    .mint-modal-overlay {
        align-items: end;
    }

    .mint-modal-content {
        width: 100%;
        max-width: 100%;
        border-radius: 12px 12px 0px 0px;
        height: 80vh;
        overflow: scroll;
        padding: 20px;
        box-shadow: 0 4px 24px rgb(0 0 0 / 39%);
    }

    .staking_page_wrapper .convert-page__faqSection {
        padding: 0px 0px 20px;
    }


}

/* Tooltip styles */
.mint-tooltip-wrapper {
    position: relative;
    display: inline-block;
    cursor: help;
    border-bottom: 1px dotted #848e9c;
}

.mint-tooltip {
    visibility: hidden;
    opacity: 0;
    width: 320px;
    background-color: #2b3139;
    color: #eaecef;
    text-align: left;
    border-radius: 6px;
    padding: 12px 16px;
    position: absolute;
    z-index: 1000;
    top: 100%;
    left: 0;
    margin-top: 8px;
    font-size: 13px;
    line-height: 1.5;
    transition: opacity 0.2s, visibility 0.2s;
    font-weight: 400;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: none;
}

.mint-tooltip::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 20px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #2b3139 transparent;
}

.mint-tooltip-wrapper:hover .mint-tooltip {
    visibility: visible;
    opacity: 1;
}

/* Intro Modal Styling */
.intro-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgb(255 255 255 / 20%) !important;
    display: flex;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    justify-content: center;
    align-items: center;
    z-index: 100000000;
    animation: fadeInModal 0.25s ease-out;
}

.intro-modal-content {
    background-color: #ffffff !important;
    color: #1e2329 !important;
    width: 95%;
    max-width: 600px;
    border-radius: 12px;
    padding: 24px;
    position: relative;
    box-shadow: 0 4px 24px rgb(0 0 0 / 26%);
    display: flex;
    flex-direction: column;
    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-sizing: border-box;
}

.intro-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.intro-modal-header h2 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
    margin-left: 8px;
}

.intro-back-btn,
.intro-close-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    color: #848e9c !important;
    cursor: pointer;
    line-height: 1;
    padding: 0;
}

.intro-back-btn:hover,
.intro-close-btn:hover {
    color: #1e2329 !important;
}

.intro-back-btn {
    font-size: 24px;
    color: #1e2329 !important;
}

.intro-tabs {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #eaecef;
    margin-bottom: 24px;
}

.intro-tab {
    font-size: 14px;
    font-weight: 600;
    color: #848e9c !important;
    padding-bottom: 12px;
    cursor: default;
    position: relative;
}

.intro-tab.active {
    color: #1e2329 !important;
}

.intro-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #1e2329;
    border-radius: 2px;
}

.intro-rule-section {
    margin-bottom: 24px;
}

.intro-rule-section h4 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px 0;
    color: #1e2329 !important;
}

.intro-rule-section p {
    font-size: 13px;
    line-height: 1.6;
    color: #848e9c !important;
    margin: 0 0 8px 0;
}

/* Service Fee Dropdown */
.service-fee-container {
    border: 1px solid #eaecef;
    border-radius: 8px;
    margin-top: 12px;
    background-color: #ffffff;
    overflow: hidden;
}

.service-fee-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #848e9c;
    font-size: 13px;
    font-weight: 500;
    padding: 12px;
    cursor: pointer;
}

.service-fee-value {
    color: #1e2329;
    display: flex;
    align-items: center;
    gap: 4px;
}

.service-fee-body {
    padding: 0 12px 12px 12px;
}

.service-fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #848e9c;
    font-size: 13px;
    margin-bottom: 8px;
}

.service-fee-row:last-child {
    margin-bottom: 0;
}

/* Tiers Timeline inside APR */
.tier-timeline {
    position: relative;
    padding-left: 6px;
    margin-top: 8px;
}

.tier-timeline::before {
    content: '';
    position: absolute;
    top: 8px;
    bottom: 12px;
    left: 12px;
    width: 1px;
    background-color: #eaecef;
    z-index: 1;
}


.tier-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1e2329;
    font-size: 13px;
    margin-bottom: 12px;
    position: relative;
    z-index: 2;
}

.tier-item:last-child {
    margin-bottom: 0;
}

.tier-item-left {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #ffffff;
}

.tier-item-left i {
    color: #848e9c;
    font-size: 16px;
}

/* Stake confirm overview popup */
.stake-overview-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000000;
    padding: 0px;
    animation: fadeInModal 0.2s ease-out;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

body.light_theme .stake-overview-overlay {
    background-color: rgb(255 255 255 / 45%);
}

.stake-overview-content {
    background: rgb(255 255 255 / 20%);
    color: #1e2329;
    width: 100%;
    max-width: 480px;
    -webkit-backdrop-filter: blur(12px);
            backdrop-filter: blur(12px);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.stake-overview-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
}

.stake-overview-header__left {
    flex: 1 1;
    min-width: 0;
}

.stake-overview-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 700;
}

.stake-overview-currency-name {
    font-size: 13px;
    color: #848e9c;
    font-weight: 400;
    margin: 4px 0 0 32px;
}

.stake-overview-subtitle {
    margin: 0 0 16px;
    font-size: 13px;
    color: #848e9c;
    line-height: 1.5;
}

.stake-overview-body {
    background: rgb(255 255 255 /20%);
    border: 1px solid rgb(102 102 102 / 15%);
    border-radius: 8px;
    padding: 4px 14px;
    margin-bottom: 16px;
    max-height: 50vh;
    overflow-y: auto;
}

.stake-overview-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.stake-overview-row:last-child {
    border-bottom: none;
}

.stake-overview-row__label {
    color: #848e9c;
    font-size: 13px;
    flex-shrink: 0;
}

.stake-overview-row__value {
    color: #1e2329;
    font-size: 13px;
    font-weight: 500;
    text-align: right;
}

.stake-overview-row__value--green {
    color: #03a66d;
}

.stake-overview-error {
    color: #f6465d;
    font-size: 13px;
    text-align: center;
    margin-bottom: 12px;
}

.stake-overview-actions {
    display: flex;
    gap: 12px;
}

.stake-overview-actions .mint-btn-cancel,
.stake-overview-actions .mint-btn-confirm {
    flex: 1 1;
}

/* Payout history modal */
.stake-payout-modal {
    max-width: 480px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

.stake-payout-modal__status {
    padding: 24px 0;
    text-align: center;
    color: #848e9c;
    font-size: 14px;
}

.stake-payout-modal__status--error {
    color: #f6465d;
}

.stake-payout-modal__summary {
    max-height: none;
    margin-bottom: 16px;
}

.stake-payout-modal__records {
    margin-bottom: 16px;
}

.stake-payout-modal__recordsTitle {
    font-size: 13px;
    font-weight: 600;
    color: #1e2329;
    margin-bottom: 10px;
}

.stake-payout-modal__empty {
    padding: 20px 14px;
    text-align: center;
    font-size: 13px;
    color: #848e9c;
    background: rgb(255 255 255 /60%);
    border-radius: 8px;
}

.stake-payout-modal__list {
    background: rgb(255 255 255 /60%);
    border-radius: 8px;
    max-height: 240px;
    overflow-y: auto;
}

.stake-payout-modal__record {
    padding: 12px 14px;
    border-bottom: 1px solid #f0f0f0;
}

.stake-payout-modal__record:last-child {
    border-bottom: none;
}

.stake-payout-modal__recordTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 6px;
}

.stake-payout-modal__recordAmount {
    font-size: 14px;
    font-weight: 600;
    color: #03a66d;
}

.stake-payout-modal__recordType {
    font-size: 12px;
    font-weight: 500;
    color: #1e2329;
    background: rgb(255 255 255 / 15%);
    border: 1px solid rgb(234 236 239 / 10%);
    border-radius: 4px;
    padding: 2px 8px;
    white-space: nowrap;
}

.stake-payout-modal__recordBottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    font-size: 12px;
    color: #848e9c;
}

.stake-payout-modal__pagination {
    margin-top: 0;
    margin-bottom: 16px;
}

.stake-payout-modal__actions {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 767px) {


    .stake-overview-overlay {
        align-items: flex-end;
    }

    .redeem-modal-footer .mint-actions {
        flex-direction: row;
    }

    .project_card {
        margin: 20px 0px;
    }

    .stake-overview-content {
        max-width: 100%;
        border-radius: 12px 12px 0 0;
        max-height: 85vh;
        overflow-y: auto;
    }

    .stake-overview-actions {
        flex-direction: column;
    }
}

/* Stake success popup */
.stake-success-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100000001;
    padding: 16px;
    animation: fadeInModal 0.2s ease-out;
}

.stake-success-content {
    background: #fff;
    color: #1e2329;
    width: 100%;
    max-width: 380px;
    border-radius: 12px;
    padding: 28px 24px 24px;
    text-align: center;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.stake-success-icon {
    font-size: 52px;
    color: #03a66d;
    line-height: 1;
    margin-bottom: 12px;
}

.stake-success-title {
    margin: 0 0 10px;
    font-size: 20px;
    font-weight: 700;
    color: #1e2329;
}

.stake-success-message {
    margin: 0 0 18px;
    font-size: 14px;
    color: #848e9c;
    line-height: 1.6;
}

.stake-success-message strong {
    color: #03a66d;
    font-weight: 600;
}

.stake-success-package {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fafafa;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 20px;
    text-align: left;
}

.stake-success-package__icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
}

.stake-success-package__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.stake-success-package__name {
    font-size: 14px;
    font-weight: 600;
    color: #1e2329;
}

.stake-success-package__meta {
    font-size: 12px;
    color: #848e9c;
}

.stake-success-btn {
    width: 100%;
}

.stake-overview-row__value--danger {
    color: #f6465d;
}

.mint-btn-confirm--danger:not(:disabled) {
    background-color: #f6465d;
    color: #fff !important;
}

.mint-btn-confirm--danger:not(:disabled):hover {
    background-color: #e03e52;
}

.cancel-staking-modal {
    max-width: 480px;
}

.cancel-staking-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.cancel-staking-warning {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 12px 14px;
    background: #fff8e6;
    border-radius: 8px;
    font-size: 13px;
    color: #92400e;
    line-height: 1.5;
}

.cancel-staking-warning i {
    font-size: 18px;
    flex-shrink: 0;
    line-height: 1;
}

.cancel-staking-warning span {
    flex: 1 1;
    min-width: 0;
}

.cancel-staking-optional {
    font-weight: 400;
    color: #848e9c;
    font-size: 12px;
}

.cancel-staking-reason {
    width: 100%;
    min-height: 88px;
    padding: 12px 14px;
    border: 1px solid #eaecef;
    border-radius: 8px;
    font-family: inherit;
    font-size: 14px;
    color: #1e2329;
    resize: vertical;
    box-sizing: border-box;
}

.cancel-staking-reason:focus {
    outline: none;
    border-color: #1a1d21;
}

.stake-overview-body--compact {
    margin-bottom: 0;
}

.stake-overview-body--inline {
    margin-bottom: 20px;
    text-align: left;
}

.stake-success-icon--cancel {
    color: #03a66d;
}

/* Dark Theme Overrides for Staking Modals */
body:not(.light_theme) .mint-modal-overlay,
body:not(.light_theme) .intro-modal-overlay,
body:not(.light_theme) .stake-overview-overlay,
body:not(.light_theme) .stake-success-overlay {
    background-color: rgba(0, 0, 0, 0.45) !important;
}

body:not(.light_theme) .mint-modal-content,
body:not(.light_theme) .intro-modal-content,
body:not(.light_theme) .stake-overview-content,
body:not(.light_theme) .stake-success-content {
    background-color: #1e232994 !important;
    background: #1e232994 !important;
    color: #ffffff !important;
    border: 1px solid #ffffff12;
}

body:not(.light_theme) .mint-info-value,
body:not(.light_theme) .mint-amount-val,
body:not(.light_theme) .mint-apr-box span:last-child,
body:not(.light_theme) .mint-timeline-lbl,
body:not(.light_theme) .mint-rules-title,
body:not(.light_theme) .stake-overview-row__value,
body:not(.light_theme) .stake-success-title,
body:not(.light_theme) .stake-success-package__name,
body:not(.light_theme) .stake-payout-modal__recordsTitle,
body:not(.light_theme) .stake-payout-modal__recordType,
body:not(.light_theme) .stake-detail-title-text {
    color: #ffffff !important;
}

body:not(.light_theme) .mint-input-box {
    border: 1px solid #ffffff12;
    background-color: #181a20;
}

body:not(.light_theme) .mint-input-box input {
    color: #ffffff !important;
}

body:not(.light_theme) .mint-input-box:focus-within {
    border-color: #5a5a5a;
}

body:not(.light_theme) .mint-apr-box,
body:not(.light_theme) .mint-daily-return-box,
body:not(.light_theme) .service-fee-container,
body:not(.light_theme) .stake-overview-body,
body:not(.light_theme) .stake-payout-modal__empty,
body:not(.light_theme) .stake-payout-modal__list,
body:not(.light_theme) .stake-payout-modal__record,
body:not(.light_theme) .stake-success-package {
    background-color: #181a2059 !important;
    background: #181a2059 !important;
    border: 1px solid #ffffff12 !important;
}

body:not(.light_theme) .service-fee-value {
    color: #ffffff !important;
}

body:not(.light_theme) .tier-item-left {
    background-color: #181a20 !important;
    color: #ffffff !important;
}

body:not(.light_theme) .tier-item {
    color: #ffffff !important;
}

body:not(.light_theme) .tier-timeline::before,
body:not(.light_theme) .mint-timeline::before {
    background-color: #ffffff12;
}

body:not(.light_theme) .mint-timeline-dot {
    background-color: #ffffff12;
}

body:not(.light_theme) .mint-timeline-dot.active {
    background-color: #ffffff;
}

body:not(.light_theme) .mint-agreement label,
body:not(.light_theme) .mint-agreement label a {
    color: #ffffff !important;
}

body:not(.light_theme) .mint-btn-cancel {
    background-color: #2b3139;
    color: #ffffff !important;
}

body:not(.light_theme) .mint-btn-confirm:not(:disabled) {
    background: #8d7650;
    color: #000;
}

body:not(.light_theme) .cancel-staking-warning {
    background: rgb(255 255 255 / 10%);
    color: #e7e7e7;
}

body:not(.light_theme) .cancel-staking-reason {
    background: #181a20;
    color: #ffffff;
    border: 1px solid #ffffff12;
}

body:not(.light_theme) .cancel-staking-reason:focus {
    border-color: #d1aa67;
}

body:not(.light_theme) .stake-overview-row {
    border-bottom: none;
}

body:not(.light_theme) .stake-payout-modal__record {
    border-bottom: none;
}

body:not(.light_theme) .mint-modal-close:hover,
body:not(.light_theme) .intro-close-btn:hover {
    color: #ffffff !important;
}

body:not(.light_theme) .mint-title-underline {
    background-color: #ffffff;
}

/* Staking Detail Modal Helpers */
.stake-detail-title-text {
    font-weight: 700;
    font-size: 16px;
    color: #1e2329;
}

body:not(.light_theme) .stake-detail-title-text {
    color: #ffffff;
}

.stake-detail-subtitle-text {
    font-weight: 400;
    color: #848e9c;
    font-size: 13px;
    margin-left: 4px;
}

.stake-detail-desc {
    font-size: 12px;
    color: #848e9c;
    margin-top: 2px;
}

.stake-detail-body {
    padding: 4px 0 0;
}

.stake-detail-badge-row {
    display: flex;
    gap: 8px;
    padding: 14px 0 10px;
    font-size: 13px;
    font-weight: 500;
    color: #848e9c;
}

body:not(.light_theme) .stake-detail-badge-row {
    color: #ffffff;
}

.stake-overview-body--penalty {
    background-color: #fff3f3 !important;
}

body:not(.light_theme) .stake-overview-body--penalty {
    background-color: #3b1b1b !important;
    border: 1px solid #ff4d4d1a !important;
}

.stake-detail-history-wrap {
    margin-top: 16px;
}

.stake-detail-history-row {
    padding: 10px 14px !important;
}

/* Plan Modal Specific Styles */
.mint-modal-content.plan-modal {
    max-width: 480px;
}

.mint-plan-modal-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 10px 0px;
}


.mint-plan-loading,
.mint-plan-empty {
    text-align: center;
    padding: 32px;
    color: #848e9c;
}

.mint-plan-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-radius: 8px;
    border: 1px solid #eaecef;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;
}

.mint-plan-card:hover {
    border-color: #d1aa67;
}

body:not(.light_theme) .mint-plan-card {
    border-color: rgba(255, 255, 255, 0.08);
}

body:not(.light_theme) .mint-plan-card:hover {
    border-color: #d1aa67;
    background-color: rgba(255, 255, 255, 0.02);
}

.mint-plan-card-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.mint-plan-card-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
}

.mint-plan-duration {
    font-weight: 600;
    font-size: 15px;
    color: #1e2329;
}

body:not(.light_theme) .mint-plan-duration {
    color: #eaecef;
}

.mint-plan-limits {
    font-size: 12px;
    color: #848e9c;
}

.mint-plan-apr-val {
    font-weight: 700;
    font-size: 16px;
    color: #03a66d;
}

.mint-plan-apr-lbl {
    font-size: 11px;
    color: #848e9c;
}

/* Mint Input Addon & Modal helper styling */
.mint-input-currency {
    font-weight: 600;
    font-size: 14px;
    color: #eaecef;
}

body.light_theme .mint-input-currency {
    color: #1e2329;
}

.mint-input-separator {
    width: 1px;
    height: 14px;
    background-color: #ffffff24;
}

body.light_theme .mint-input-separator {
    background-color: #eaecef;
}

.mint-info-item-right {
    text-align: right;
}

.mint-error-msg {
    color: #f6465d;
    font-size: 12px;
    margin-top: 6px;
}

.mint-error-msg-center {
    font-size: 13px;
    margin-top: 8px;
    text-align: center;
}

.mint-apr-box-col {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
}

.mint-apr-standard-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}

.mint-apr-value {
    color: #ffffff;
    font-weight: 600;
}

body.light_theme .mint-apr-value {
    color: #1e2329;
}

.mint-bonus-apr-label {
    color: #848e9c;
    border-bottom: 1px dotted #848e9c;
    display: inline-block;
    width: -moz-fit-content;
    width: fit-content;
    margin-bottom: 8px;
    font-size: 13px;
    padding-bottom: 2px;
}

.mint-arrow-icon {
    color: #eaecef;
}

body.light_theme .mint-arrow-icon {
    color: #4b4f56;
}

.mint-daily-return-col {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
}

.mint-daily-return-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mint-table-empty {
    text-align: center;
    padding: 32px;
}

.mint-cards-wrapper {
    margin-top: 20px;
}

.mint-btn-full {
    width: 100%;
    padding: 12px;
}

.mint-cursor-pointer {
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Staking/staking.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;;AAGA;;IAEI;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;;AAIA,kCAAkC;AAClC;;IAEI;;;;;;QAMI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,QAAQ;QACR,8BAA8B;QAC9B,aAAa;QACb,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,4BAA4B;QAC5B,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI;YACI,2BAA2B;QAC/B;;QAEA;YACI,wBAAwB;QAC5B;IACJ;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,gCAAgC;QAChC,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,+BAA+B;QAC/B,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,YAAY;QACZ,UAAU;QACV,UAAU;QACV,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,cAAc;IACd,eAAe;IACf,oCAAoC;;AAExC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,cAAc;IACd,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,gCAAgC;QAChC,gBAAgB;QAChB,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;IACb,mDAAmD;IACnD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gCAAgC;QAChC,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,uCAAuC;IAC3C;;IAEA;QACI,qBAAqB;IACzB;;;AAGJ;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yCAAyC;IACzC,gBAAgB;IAChB,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;AAC7D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mDAAmD;IACnD,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,0DAA0D;IAC1D,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;IACP,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,QAAQ;IACR,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;;IAEI,SAAO;AACX;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;;IAGI;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,4BAA4B;QAC5B,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,QAAQ;IACR,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,2DAA2D;AAC/D;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;;;;IAII,gDAAgD;AACpD;;AAEA;;;;IAII,sCAAsC;IACtC,gCAAgC;IAChC,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;;;;;;;;;;IAWI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;;;;IAQI,sCAAsC;IACtC,gCAAgC;IAChC,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;;;AAGA;;IAEI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,oDAAoD;AACxD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;AACV;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,qBAAqB;IACrB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".staking_page_wrapper {\n    width: 100%;\n    padding: 60px 0px;\n    color: #fff;\n}\n\n\nbody .text-black {\n    color: #d3d3d3 !important;\n}\n\nbody.light_theme .text-black {\n    color: #111 !important;\n}\n\nbody.light_theme .staking_page_wrapper {\n    color: #1a1a1a;\n}\n\n.staking_page_wrapper .container {\n    max-width: 1240px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.staking_bnr_cnt {\n    justify-content: space-between;\n    align-items: center;\n    gap: 32px;\n    margin-bottom: 60px;\n}\n\n.staking_title {\n    font-size: 48px;\n    font-weight: 700;\n    margin: 0;\n}\n\n\n.staking_page_wrapper .convert-page__faqSection {\n    padding: 0px 0px 50px;\n}\n\n.staking_page_wrapper p.staking_desc {\n    font-size: 18px;\n    color: #84888C;\n    font-weight: 500;\n    margin-top: 15px;\n}\n\n.staking_page_wrapper .staking_btn {\n    padding-top: 15px;\n}\n\n.staking_page_wrapper .staking_btn button {\n    font-size: 15px;\n    color: #070808;\n    background-color: #F5F6F7;\n    border-radius: 50px;\n    padding: 16px 24px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n}\n\n.staking_page_wrapper .staking_btn button.loginbtn {\n    background-color: #303236;\n    color: #fff;\n}\n\n.staking_img {\n    max-width: 450px;\n}\n\n.staking_info_section {\n    margin: 100px 0px 70px;\n}\n\n.staking_info_title {\n    font-size: 28px;\n    font-weight: 600;\n    margin-bottom: 32px;\n    color: #fff;\n}\n\nbody.light_theme .staking_info_title {\n    color: #070808;\n}\n\n.staking_info_cards {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    padding-top: 25px;\n}\n\n.staking_info_card {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding-left: 85px;\n}\n\n.staking_info_icon {\n    width: 80px;\n    height: 80px;\n    border: 1px solid #EFDEC2;\n    margin-bottom: 24px;\n    border-radius: 50%;\n    box-shadow: 0px 1px 10px #0000001c;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.staking_info_card .number {\n    font-size: 60px;\n    color: #F3EBDF;\n    font-weight: 700;\n    position: absolute;\n    left: 0px;\n}\n\n.staking_info_icon img {\n    object-fit: contain;\n}\n\n.staking_info_card h3 {\n    font-size: 20px;\n    font-weight: 600;\n    color: #dddddd;\n    margin: 0 0 12px 0;\n}\n\nbody.light_theme .staking_info_card h3 {\n    color: #111;\n}\n\n.staking_info_card p {\n    font-size: 16px;\n    color: #84888C;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.nextarrow_step {\n    font-size: 36px;\n    color: #E5E7EB;\n    position: absolute;\n    right: -20px;\n    font-weight: 200;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    z-index: 10;\n}\n\n.staking_products_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n}\n\n.staking_products_header h2 {\n    font-size: 28px;\n    font-weight: 700;\n    margin: 0;\n    color: #fff;\n}\n\nbody.light_theme .staking_products_header h2 {\n    color: #111;\n}\n\n.staking_products_filters {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n.staking_checkbox_label {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    color: #fff;\n    cursor: pointer;\n}\n\nbody.staking_checkbox_label {\n    color: #070808;\n}\n\n.staking_checkbox_label input {\n    width: 16px;\n    height: 16px;\n    accent-color: #333;\n    cursor: pointer;\n}\n\n.staking_search_bar {\n    display: flex;\n    align-items: center;\n    background-color: #f6f6f708;\n    border-radius: 6px;\n    padding: 8px 16px;\n    gap: 10px;\n    width: 240px;\n}\n\nbody.light_theme .staking_search_bar {\n    background-color: #F6F6F7;\n}\n\n.staking_search_bar input {\n    border: none;\n    background: transparent;\n    outline: none;\n    font-size: 14px;\n    width: 100%;\n    color: #e4e4e4;\n}\n\nbody.light_theme .staking_search_bar input {\n    color: #111;\n}\n\n.staking_search_bar input::placeholder {\n    color: #a0a5aa;\n}\n\n.staking_table_container {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.staking_table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n}\n\n.staking_table th {\n    padding: 16px;\n    color: #848e9c;\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.staking_table th .sort_icon {\n    font-size: 10px;\n    margin-left: 4px;\n    color: #a0a5aa;\n}\n\n.staking_table td {\n    padding: 24px 16px;\n    /* border-bottom: 1px solid #f5f6f7; */\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n}\n\nbody.light_theme .staking_table td {\n    color: #1e2329;\n}\n\n.staking_table .action_th,\n.staking_table .action_td {\n    text-align: right;\n    width: auto;\n    float: right;\n}\n\n.coin_cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.coin_icon_stak {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.staking_page_wrapper .coin_name {\n    font-weight: 500;\n    color: #fff;\n    font-size: 16px;\n}\n\nbody.light_theme .staking_page_wrapper .coin_name {\n    color: #070808;\n}\n\n.staking_page_wrapper .coin_badge {\n    font-size: 11px;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-weight: 600;\n}\n\n.badge_bonus {\n    background-color: #8FFCDE;\n    color: #000000;\n}\n\n.badge_vip {\n    background-color: #FFD98F;\n    color: #000000;\n}\n\n.badge_new {\n    background-color: #52FFB1;\n    color: #000000;\n}\n\n.fire_icon {\n    font-size: 14px;\n}\n\n.apr_cell {\n    font-weight: 600;\n    color: #1e2329;\n}\n\n.reward_icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: bold;\n    font-size: 10px;\n}\n\n.multiple_rewards {\n    display: flex;\n    align-items: center;\n}\n\n.multiple_rewards .reward_icon {\n    margin-left: -8px;\n    border: 2px solid white;\n}\n\n.multiple_rewards .reward_icon:first-child {\n    margin-left: 0;\n}\n\n.type_cell {\n    font-weight: 600;\n    color: #4b4f56;\n}\n\n.action_btn {\n    background-color: #2b3139;\n    color: white;\n    border: none;\n    padding: 8px 24px;\n    border-radius: 20px;\n    font-weight: 500;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.action_btn:hover {\n    background-color: #1e2329;\n}\n\n.mobile_action_btns {\n    display: none;\n}\n\n.staking_pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n    gap: 8px;\n}\n\n.page_num,\n.page_nav {\n    background: none;\n    border: none;\n    font-size: 14px;\n    font-weight: 600;\n    color: #4b4f56;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.page_num:hover,\n.page_nav:hover {\n    background-color: #f5f6f7;\n}\n\n.page_num.active {\n    background-color: #f5f6f7;\n    color: #111;\n}\n\n/* Why Stake Section */\n.why_stake_section_new {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 100px 0px;\n}\n\n.why_stake_left {\n    flex: 1;\n}\n\n.why_stake_right {\n    flex: 1 1;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n}\n\n.why_stake_right img {\n    max-width: 240px;\n}\n\n.why_stake_cards {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 30px;\n}\n\n.why_stake_card {\n    display: flex;\n    align-items: center;\n    background-color: #fafafa0a;\n    border: 1px solid #f3f4f60d;\n    padding: 30px;\n    position: relative;\n    border-radius: 14px;\n}\n\nbody.light_theme .why_stake_card {\n    background-color: #fafafa;\n    border: 1px solid #F3F4F6;\n}\n\n.why_stake_card::before {\n    content: \"\";\n    width: 3px;\n    height: 30px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0px;\n    left: 0;\n    background-color: #C59D5F;\n    border-radius: 2px;\n    z-index: 999;\n}\n\n.why_stake_card_icon {\n    width: 50px;\n    height: 50px;\n    border: 1px solid #F3F4F6;\n    min-width: 50px;\n    background-color: white;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.why_stake_card_icon img {\n    width: 28px;\n    height: 28px;\n    object-fit: contain;\n}\n\n.why_stake_card_content h3 {\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0 0 5px 0;\n}\n\n.why_stake_card_content p {\n    font-size: 13px;\n    color: #84888C;\n    margin: 0;\n}\n\n/* How to Stake Section */\n.how_stake_section {\n    margin-bottom: 100px;\n}\n\n.how_stake_timeline {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    margin-top: 60px;\n    gap: 32px;\n}\n\n.timeline_line {\n    position: absolute;\n    top: 40px;\n    left: 10%;\n    right: 10%;\n    height: 1px;\n    border-top: 1px dashed #eaecef;\n    background-color: transparent;\n    z-index: 1;\n}\n\n.timeline_step {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    position: relative;\n    z-index: 2;\n}\n\n.step_icon_container {\n    position: relative;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.step_icon {\n    width: 94px;\n    border: 1px solid #c4c6cf42;\n    height: 94px;\n    background-color: #171a20;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .step_icon {\n    background-color: white;\n}\n\n.step_icon img {\n    width: 32px;\n    height: 32px;\n    object-fit: contain;\n    filter: invert(1);\n}\n\nbody.light_theme .step_icon img {\n    filter: invert(0);\n}\n\n.step_number {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background-color: #171a20;\n    color: #e0e0e0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    font-size: 12px;\n    position: absolute;\n    top: -8px;\n    border: 1px solid #C4C6CF30;\n}\n\nbody.light_theme .step_number {\n    background-color: #F7F9FB;\n    color: #292b2f;\n}\n\n.timeline_step h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n}\n\n.timeline_step p {\n    font-size: 13px;\n    color: #84888C;\n    margin: 0;\n    max-width: 370px;\n}\n\n\n@media (max-width: 1366px) {\n\n    .staking_title {\n        font-size: 38px;\n    }\n\n\n}\n\n\n@media (max-width: 1200px) {\n\n    .staking_title {\n        font-size: 32px;\n    }\n\n    .staking_img {\n        max-width: 300px;\n    }\n\n\n    .staking_page_wrapper .staking_btn button {\n        font-size: 14px;\n        padding: 10px 20px;\n    }\n\n    .why_stake_card_content h3 {\n        font-size: 18px;\n    }\n\n    .staking_info_title {\n        font-size: 24px;\n    }\n\n}\n\n@media (max-width: 991px) {\n\n    .staking_info_card .number {\n        font-size: 40px;\n    }\n\n    .staking_info_card {\n        padding-left: 65px;\n    }\n\n    .staking_info_card h3 {\n        font-size: 18px;\n    }\n\n    .staking_info_card p {\n        font-size: 14px;\n    }\n\n}\n\n\n\n/* Mobile Table and Popup styles */\n@media (max-width: 767px) {\n\n    .staking_table th:nth-child(3),\n    .staking_table th:nth-child(4),\n    .staking_table th:nth-child(5),\n    .staking_table td:nth-child(3),\n    .staking_table td:nth-child(4),\n    .staking_table td:nth-child(5) {\n        display: none;\n    }\n\n    .why_stake_section_new {\n        margin: 40px 0px;\n    }\n\n    .staking_table th:nth-child(2),\n    .staking_table td:nth-child(2) {\n        text-align: right;\n    }\n\n    .staking_table th:nth-child(1),\n    .staking_table td:nth-child(1) {\n        padding-left: 10px;\n    }\n\n    .staking_table tbody tr {\n        cursor: pointer;\n    }\n\n    .mobile_staking_popup_overlay {\n        position: fixed;\n        inset: 0;\n        background: rgba(0, 0, 0, 0.4);\n        z-index: 1000;\n        display: flex;\n        align-items: flex-end;\n    }\n\n    .mobile_staking_popup {\n        background: #fff;\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        padding: 24px;\n        animation: slideUp 0.3s ease;\n    }\n\n    @keyframes slideUp {\n        from {\n            transform: translateY(100%);\n        }\n\n        to {\n            transform: translateY(0);\n        }\n    }\n\n    .mobile_staking_popup .popup_header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 20px;\n    }\n\n    .mobile_staking_popup .popup_header h3 {\n        margin: 0;\n        font-size: 20px;\n        font-weight: 700;\n    }\n\n    .mobile_staking_popup .close_btn {\n        background: none;\n        border: none;\n        font-size: 28px;\n        color: #84888C;\n        cursor: pointer;\n    }\n\n    .mobile_staking_popup .popup_row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 15px 0;\n        border-bottom: 1px solid #f0f0f0;\n        font-size: 15px;\n    }\n\n    .mobile_staking_popup .popup_row:last-child {\n        border-bottom: none;\n    }\n\n    .mobile_staking_popup .popup_row span:first-child {\n        color: #84888C;\n    }\n\n    .mobile_staking_popup .apr_val {\n        color: #111;\n        font-weight: 600;\n    }\n\n    .reward_popup_icons {\n        display: flex;\n        gap: 6px;\n    }\n\n    .reward_popup_icon {\n        width: 24px;\n        height: 24px;\n    }\n\n    .mobile_staking_popup .popup_footer {\n        margin-top: 18px;\n    }\n\n    .mobile_staking_popup .popup_footer .action_btn {\n        font-size: 13px;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px;\n        padding: 8px !important;\n    }\n\n    .mobile_action_btns {\n        display: flex;\n        gap: 12px;\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 660px) {\n\n    .staking_bnr_cnt {\n        flex-direction: column;\n        gap: 32px;\n        margin-bottom: 40px;\n        text-align: center;\n    }\n\n    .staking_info_card .number {\n        display: none;\n    }\n\n    .staking_title {\n        font-size: 24px;\n    }\n\n    .staking_table td {\n        padding: 15px 10px;\n        font-size: 14px;\n    }\n\n    .staking_page_wrapper .coin_name {\n        font-size: 14px;\n    }\n\n    .staking_pagination {\n        margin-top: 20px;\n    }\n\n    .staking_page_wrapper p.staking_desc {\n        font-size: 15px;\n        margin-top: 10px;\n    }\n\n    .staking_img {\n        max-width: 240px;\n    }\n\n\n    .staking_page_wrapper {\n        padding: 50px 0px;\n    }\n\n    .staking_page_wrapper .staking_btn {\n        padding-top: 0px;\n        justify-content: center;\n    }\n\n    .staking_products_header h2 {\n        font-size: 20px;\n    }\n\n    .staking_products_header {\n        align-items: start;\n        margin-bottom: 20px;\n        gap: 20px;\n    }\n\n    .staking_info_cards {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n    }\n\n    .staking_info_title {\n        font-size: 20px;\n        margin-bottom: 0px;\n        text-align: center;\n    }\n\n    .why_stake_section_new {\n        flex-direction: column;\n        margin-bottom: 50px;\n    }\n\n    .why_stake_right {\n        margin-top: 32px;\n    }\n\n    .why_stake_card_content h3 {\n        font-size: 16px;\n    }\n\n    .timeline_step {\n        display: grid;\n        grid-template-columns: 60px 1fr;\n        column-gap: 16px;\n        row-gap: 6px;\n        text-align: left;\n    }\n\n    .step_icon_container {\n        grid-column: 1;\n        grid-row: 1 / span 2;\n        margin: 0;\n        z-index: 2;\n    }\n\n    .step_icon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .step_icon img {\n        width: 24px;\n        height: 24px;\n    }\n\n    .step_number {\n        width: 20px;\n        height: 20px;\n        font-size: 10px;\n        top: -6px;\n    }\n\n    .timeline_step h3 {\n        font-size: 16px;\n        margin: 0px;\n        align-self: end;\n    }\n\n    .timeline_step p {\n        max-width: 100%;\n        font-size: 13px;\n        align-self: start;\n        margin: 0;\n    }\n\n    .how_stake_section {\n        margin-bottom: 40px;\n    }\n\n    .how_stake_timeline {\n        display: flex;\n        flex-direction: column;\n        gap: 32px;\n        margin-top: 30px;\n        position: relative;\n    }\n\n    .timeline_line {\n        top: 20px;\n        bottom: 30px;\n        left: 25px;\n        width: 1px;\n        height: auto;\n        right: auto;\n        border-top: none;\n        border-left: 1px dashed #eaecef;\n        background-color: transparent;\n    }\n\n    .staking_info_section {\n        margin: 40px 0px 40px;\n        text-align: center;\n    }\n\n    .staking_info_card h3 {\n        font-size: 16px;\n        margin-top: 15px;\n    }\n\n    .staking_info_icon {\n        width: 54px;\n        height: 54px;\n        margin: 0 auto;\n    }\n\n    .staking_info_card {\n        border-radius: 0px;\n        padding: 0px;\n    }\n\n    .staking_info_card p {\n        font-size: 13px;\n    }\n\n    .nextarrow_step {\n        display: none;\n    }\n\n}\n\n/* Staking Detail / Help Center Layout */\n.staking_detail_wrapper {\n    width: 100%;\n    padding: 40px 0;\n    color: #e5e5e5;\n    background-color: #171a20;\n    min-height: 80vh;\n}\n\nbody.light_theme .staking_detail_wrapper {\n    background-color: #fff;\n    color: #111;\n}\n\n.staking_detail_wrapper .container {\n    max-width: 1240px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n.hc_breadcrumb {\n    font-size: 16px;\n    color: #A0A3A7;\n    margin-bottom: 40px;\n}\n\n.hc_breadcrumb .hc_link {\n    cursor: pointer;\n}\n\n.hc_breadcrumb .hc_link:hover {\n    opacity: 0.8;\n}\n\nbody.light_theme .hc_breadcrumb .hc_link:hover {\n    color: #111;\n}\n\n.hc_breadcrumb .hc_sep {\n    margin: 0 8px;\n    font-size: 12px;\n}\n\n.hc_breadcrumb .hc_current {\n    color: #dadada;\n    font-weight: 500;\n}\n\nbody.light_theme .hc_breadcrumb .hc_current {\n    color: #111;\n}\n\n.hc_layout {\n    display: flex;\n    gap: 40px;\n}\n\n.hc_sidebar {\n    width: 260px;\n    flex-shrink: 0;\n    border-bottom: none;\n    padding-right: 40px;\n}\n\n\n.hc_mobile_toggle {\n    display: none;\n}\n\n.hc_sidebar_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 0;\n    font-size: 16px;\n    color: #dadada;\n    cursor: pointer;\n    border-bottom: 1px solid transparent;\n\n}\n\nbody.light_theme .hc_sidebar_item {\n    color: #484B51;\n}\n\n.hc_sidebar_item:hover {\n    color: #dedede;\n}\n\nbody.light_theme .hc_sidebar_item:hover {\n    color: #111;\n}\n\n.hc_sidebar_item .font-weight-bold {\n    font-weight: 600;\n}\n\n.hc_sidebar_item .text-black {\n    color: #111;\n}\n\n\n.hc_chev {\n    color: #848e9c;\n    transition: transform 0.2s ease;\n    transform: rotate(0deg);\n}\n\n.hc_chev.open {\n    transform: rotate(90deg);\n}\n\n.hc_submenu {\n    padding-left: 20px;\n    margin-top: 8px;\n    margin-bottom: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.hc_submenu_item {\n    font-size: 16px;\n    color: #d6d6d6;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\nbody.light_theme .hc_submenu_item {\n    color: #484B51;\n}\n\n.hc_submenu_item:hover {\n    color: #e0e0e0;\n}\n\nbody.light_theme .hc_submenu_item:hover {\n    color: #111;\n}\n\n.hc_submenu_item.active_sub {\n    font-weight: 600;\n    color: #dfdfdf;\n}\n\nbody.light_theme .hc_submenu_item.active_sub {\n    color: #111;\n}\n\n.hc_main_content {\n    flex-grow: 1;\n}\n\n.hc_content_section {\n    margin-bottom: 18px;\n}\n\n.hc_section_header {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    padding-bottom: 16px;\n    cursor: pointer;\n}\n\n.hc_section_header h2 {\n    font-size: 19px;\n    font-weight: 600;\n    margin: 0;\n    color: #dedede;\n}\n\nbody.light_theme .hc_section_header h2 {\n    color: #111;\n}\n\n.hc_section_chev {\n    color: #dedede;\n    transition: transform 0.2s ease;\n    transform: rotate(90deg);\n}\n\nbody.light_theme .hc_section_chev {\n    color: #111;\n}\n\n.hc_section_chev.open {\n    transform: rotate(-90deg);\n}\n\n.hc_article_grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px 40px;\n    padding-bottom: 24px;\n}\n\n.hc_article_item {\n    font-size: 16px;\n    line-height: 1.5;\n}\n\n.hc_article_item a {\n    color: #c1c1c1;\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\nbody.light_theme .hc_article_item a {\n    color: #4b4f56;\n}\n\n.hc_article_item a:hover {\n    color: #c1c1c1;\n}\n\nbody.light_theme .hc_article_item a:hover {\n    color: #111;\n}\n\n@media (max-width: 767px) {\n    .hc_layout {\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .hc_mobile_toggle {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        margin-bottom: 0px;\n        cursor: pointer;\n    }\n\n    .hc_mobile_toggle h2 {\n        font-size: 16px;\n        font-weight: 600;\n        margin: 0;\n        color: #111;\n    }\n\n    .hc_section_header h2 {\n        font-size: 16px;\n    }\n\n    .hc_article_item {\n        font-size: 14px;\n    }\n\n    .hc_sidebar {\n        display: none;\n        width: 100%;\n        border-right: none;\n        border-bottom: 1px solid #eaecef;\n        padding-right: 0;\n        padding-bottom: 20px;\n        margin-bottom: 20px;\n    }\n\n    .hc_sidebar.mobile_open {\n        display: block;\n    }\n\n    .hc_article_grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* Mint Modal styling */\n.mint-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    backdrop-filter: blur(5px);\n    height: 100vh;\n    background-color: rgb(255 255 255 / 20%) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 99999999;\n    animation: fadeInModal 0.25s ease-out;\n}\n\n.mint-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n    width: 95%;\n    max-width: 800px;\n    border-radius: 12px;\n    padding: 24px 32px;\n    position: relative;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\n.mint-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.mint-modal-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 20px;\n    font-weight: 700;\n}\n\n.mint-title-icon {\n    width: 24px;\n    height: 24px;\n}\n\n.mint-modal-close {\n    background: transparent;\n    border: none;\n    font-size: 24px;\n    color: #848e9c !important;\n    cursor: pointer;\n    transition: color 0.2s;\n    line-height: 1;\n}\n\n.mint-modal-close:hover {\n    color: #1e2329 !important;\n}\n\n.mint-modal-body {\n    display: flex;\n    gap: 40px;\n}\n\n/* Left Column */\n.mint-modal-left {\n    flex: 1;\n}\n\n.mint-info-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.mint-info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.mint-info-label {\n    font-size: 13px;\n    color: #848e9c !important;\n    font-weight: 500;\n}\n\n.mint-info-value {\n    font-size: 16px;\n    font-weight: 600;\n    color: #1e2329 !important;\n}\n\n.mint-green-text {\n    color: #03a66d !important;\n}\n\n.mint-section-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    margin-bottom: 12px;\n}\n\n.mint-input-box {\n    display: flex;\n    align-items: center;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 10px 16px;\n    transition: border-color 0.2s;\n}\n\n.mint-input-box:focus-within {\n    border-color: #1a1d21;\n}\n\n.mint-input-box input {\n    flex: 1;\n    border: none;\n    background: none;\n    outline: none;\n    font-size: 14px;\n    color: #1e2329 !important;\n}\n\n.mint-input-addon {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.mint-max-btn {\n    color: #d1aa67 !important;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.mint-currency-dropdown {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.mint-amount-details {\n    margin-top: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 32px;\n}\n\n.mint-amount-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.mint-amount-lbl {\n    color: #848e9c !important;\n}\n\n.mint-amount-lbl--inline {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.mint-amount-info-tooltip {\n    border-bottom: none;\n    cursor: help;\n    color: #848e9c;\n    font-size: 14px;\n    line-height: 1;\n}\n\n.mint-amount-info-tooltip .mint-tooltip {\n    width: 220px;\n    left: 50%;\n    transform: translateX(-50%);\n    text-align: center;\n}\n\n.mint-amount-info-tooltip .mint-tooltip::after {\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.mint-amount-val {\n    color: #1e2329 !important;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.mint-add-icon {\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.mint-apr-box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 16px;\n    font-size: 14px;\n    color: #848e9c !important;\n}\n\n.mint-apr-box span:last-child {\n    font-weight: 600;\n    color: #1e2329 !important;\n}\n\n/* Right Column */\n.mint-modal-right {\n    flex: 1;\n}\n\n.mint-daily-return-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 8px;\n}\n\n.mint-daily-return-box {\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    padding: 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 32px;\n}\n\n.mint-return-icon {\n    width: 20px;\n    height: 20px;\n}\n\n.mint-return-val {\n    font-size: 14px;\n    font-weight: 600;\n    color: #12a771 !important;\n}\n\n.mint-rules-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #eaecef;\n    padding-bottom: 8px;\n}\n\n.mint-rules-title {\n    font-size: 14px;\n    font-weight: 600;\n    position: relative;\n}\n\n.mint-title-underline {\n    position: absolute;\n    bottom: -9px;\n    left: 0;\n    width: 20px;\n    height: 3px;\n    background-color: #1e2329;\n    border-radius: 2px;\n}\n\n.mint-rules-link {\n    font-size: 13px;\n    color: #848e9c !important;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n}\n\n.mint-timeline {\n    position: relative;\n    padding-left: 12px;\n}\n\n.mint-timeline::before {\n    content: '';\n    position: absolute;\n    top: 6px;\n    bottom: 20px;\n    left: 14px;\n    width: 1px;\n    background-color: #eaecef;\n}\n\n.mint-timeline-item {\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.mint-timeline-item.last {\n    margin-bottom: 0;\n}\n\n.mint-timeline-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #eaecef;\n    margin-top: 6px;\n    margin-right: 16px;\n    position: relative;\n    z-index: 2;\n}\n\n.mint-timeline-dot.active {\n    background-color: #1e2329;\n}\n\n.mint-timeline-dot.icon {\n    background-color: transparent;\n    margin-top: 2px;\n    margin-left: -3px;\n    font-size: 14px;\n    color: #848e9c;\n}\n\n.mint-timeline-content {\n    flex: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    font-size: 13px;\n}\n\n.mint-timeline-lbl {\n    color: #1e2329 !important;\n}\n\n.mint-timeline-val {\n    color: #848e9c !important;\n    text-align: right;\n}\n\n.mint-timeline-val.multi-line {\n    line-height: 1.4;\n}\n\n.redeem-modal-content {\n    max-width: 480px;\n    padding: 24px;\n}\n\n.redeem-modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.redeem-modal-timeline {\n    margin-top: 4px;\n}\n\n.redeem-modal-footer {\n    margin-top: 24px;\n    justify-content: flex-end;\n}\n\n.redeem-modal-footer .mint-actions {\n    margin-left: auto;\n}\n\n/* Footer */\n.mint-modal-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 40px;\n}\n\n.mint-agreement {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n}\n\n.mint-agreement input {\n    cursor: pointer;\n}\n\n.mint-agreement label {\n    color: #1e2329 !important;\n}\n\n.mint-agreement a {\n    color: #1e2329 !important;\n    text-decoration: underline;\n}\n\n.mint-actions {\n    display: flex;\n    gap: 12px;\n}\n\n.mint-btn-cancel {\n    background-color: #f5f6f7;\n    color: #1e2329 !important;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 24px;\n    font-weight: 600;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.mint-btn-confirm {\n    background-color: #f5f6f7;\n    color: #b7bdc6 !important;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 24px;\n    font-weight: 600;\n    cursor: not-allowed;\n    font-size: 14px;\n}\n\n.mint-btn-confirm:not(:disabled) {\n    background: #1a1d21;\n    color: #fff;\n    cursor: pointer;\n}\n\n@media (max-width: 767px) {\n    .mint-modal-body {\n        flex-direction: column;\n        gap: 24px;\n    }\n\n    .mint-modal-footer {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 20px;\n    }\n\n    .mint-actions {\n        flex-direction: column;\n    }\n\n    .mint-btn-cancel,\n    .mint-btn-confirm {\n        width: 100%;\n    }\n\n    .mint-modal-overlay {\n        align-items: end;\n    }\n\n    .mint-modal-content {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 12px 12px 0px 0px;\n        height: 80vh;\n        overflow: scroll;\n        padding: 20px;\n        box-shadow: 0 4px 24px rgb(0 0 0 / 39%);\n    }\n\n    .staking_page_wrapper .convert-page__faqSection {\n        padding: 0px 0px 20px;\n    }\n\n\n}\n\n/* Tooltip styles */\n.mint-tooltip-wrapper {\n    position: relative;\n    display: inline-block;\n    cursor: help;\n    border-bottom: 1px dotted #848e9c;\n}\n\n.mint-tooltip {\n    visibility: hidden;\n    opacity: 0;\n    width: 320px;\n    background-color: #2b3139;\n    color: #eaecef;\n    text-align: left;\n    border-radius: 6px;\n    padding: 12px 16px;\n    position: absolute;\n    z-index: 1000;\n    top: 100%;\n    left: 0;\n    margin-top: 8px;\n    font-size: 13px;\n    line-height: 1.5;\n    transition: opacity 0.2s, visibility 0.2s;\n    font-weight: 400;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    pointer-events: none;\n}\n\n.mint-tooltip::after {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    left: 20px;\n    border-width: 6px;\n    border-style: solid;\n    border-color: transparent transparent #2b3139 transparent;\n}\n\n.mint-tooltip-wrapper:hover .mint-tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n/* Intro Modal Styling */\n.intro-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgb(255 255 255 / 20%) !important;\n    display: flex;\n    backdrop-filter: blur(5px);\n    justify-content: center;\n    align-items: center;\n    z-index: 100000000;\n    animation: fadeInModal 0.25s ease-out;\n}\n\n.intro-modal-content {\n    background-color: #ffffff !important;\n    color: #1e2329 !important;\n    width: 95%;\n    max-width: 600px;\n    border-radius: 12px;\n    padding: 24px;\n    position: relative;\n    box-shadow: 0 4px 24px rgb(0 0 0 / 26%);\n    display: flex;\n    flex-direction: column;\n    animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n    box-sizing: border-box;\n}\n\n.intro-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.intro-modal-header h2 {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0;\n    flex: 1;\n    margin-left: 8px;\n}\n\n.intro-back-btn,\n.intro-close-btn {\n    background: transparent;\n    border: none;\n    font-size: 20px;\n    color: #848e9c !important;\n    cursor: pointer;\n    line-height: 1;\n    padding: 0;\n}\n\n.intro-back-btn:hover,\n.intro-close-btn:hover {\n    color: #1e2329 !important;\n}\n\n.intro-back-btn {\n    font-size: 24px;\n    color: #1e2329 !important;\n}\n\n.intro-tabs {\n    display: flex;\n    gap: 24px;\n    border-bottom: 1px solid #eaecef;\n    margin-bottom: 24px;\n}\n\n.intro-tab {\n    font-size: 14px;\n    font-weight: 600;\n    color: #848e9c !important;\n    padding-bottom: 12px;\n    cursor: default;\n    position: relative;\n}\n\n.intro-tab.active {\n    color: #1e2329 !important;\n}\n\n.intro-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background-color: #1e2329;\n    border-radius: 2px;\n}\n\n.intro-rule-section {\n    margin-bottom: 24px;\n}\n\n.intro-rule-section h4 {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 12px 0;\n    color: #1e2329 !important;\n}\n\n.intro-rule-section p {\n    font-size: 13px;\n    line-height: 1.6;\n    color: #848e9c !important;\n    margin: 0 0 8px 0;\n}\n\n/* Service Fee Dropdown */\n.service-fee-container {\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    margin-top: 12px;\n    background-color: #ffffff;\n    overflow: hidden;\n}\n\n.service-fee-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #848e9c;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 12px;\n    cursor: pointer;\n}\n\n.service-fee-value {\n    color: #1e2329;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.service-fee-body {\n    padding: 0 12px 12px 12px;\n}\n\n.service-fee-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #848e9c;\n    font-size: 13px;\n    margin-bottom: 8px;\n}\n\n.service-fee-row:last-child {\n    margin-bottom: 0;\n}\n\n/* Tiers Timeline inside APR */\n.tier-timeline {\n    position: relative;\n    padding-left: 6px;\n    margin-top: 8px;\n}\n\n.tier-timeline::before {\n    content: '';\n    position: absolute;\n    top: 8px;\n    bottom: 12px;\n    left: 12px;\n    width: 1px;\n    background-color: #eaecef;\n    z-index: 1;\n}\n\n\n.tier-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #1e2329;\n    font-size: 13px;\n    margin-bottom: 12px;\n    position: relative;\n    z-index: 2;\n}\n\n.tier-item:last-child {\n    margin-bottom: 0;\n}\n\n.tier-item-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #ffffff;\n}\n\n.tier-item-left i {\n    color: #848e9c;\n    font-size: 16px;\n}\n\n/* Stake confirm overview popup */\n.stake-overview-overlay {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100000000;\n    padding: 0px;\n    animation: fadeInModal 0.2s ease-out;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .stake-overview-overlay {\n    background-color: rgb(255 255 255 / 45%);\n}\n\n.stake-overview-content {\n    background: rgb(255 255 255 / 20%);\n    color: #1e2329;\n    width: 100%;\n    max-width: 480px;\n    backdrop-filter: blur(12px);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);\n    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.stake-overview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 8px;\n}\n\n.stake-overview-header__left {\n    flex: 1;\n    min-width: 0;\n}\n\n.stake-overview-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.stake-overview-currency-name {\n    font-size: 13px;\n    color: #848e9c;\n    font-weight: 400;\n    margin: 4px 0 0 32px;\n}\n\n.stake-overview-subtitle {\n    margin: 0 0 16px;\n    font-size: 13px;\n    color: #848e9c;\n    line-height: 1.5;\n}\n\n.stake-overview-body {\n    background: rgb(255 255 255 /20%);\n    border: 1px solid rgb(102 102 102 / 15%);\n    border-radius: 8px;\n    padding: 4px 14px;\n    margin-bottom: 16px;\n    max-height: 50vh;\n    overflow-y: auto;\n}\n\n.stake-overview-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 10px 0;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.stake-overview-row:last-child {\n    border-bottom: none;\n}\n\n.stake-overview-row__label {\n    color: #848e9c;\n    font-size: 13px;\n    flex-shrink: 0;\n}\n\n.stake-overview-row__value {\n    color: #1e2329;\n    font-size: 13px;\n    font-weight: 500;\n    text-align: right;\n}\n\n.stake-overview-row__value--green {\n    color: #03a66d;\n}\n\n.stake-overview-error {\n    color: #f6465d;\n    font-size: 13px;\n    text-align: center;\n    margin-bottom: 12px;\n}\n\n.stake-overview-actions {\n    display: flex;\n    gap: 12px;\n}\n\n.stake-overview-actions .mint-btn-cancel,\n.stake-overview-actions .mint-btn-confirm {\n    flex: 1;\n}\n\n/* Payout history modal */\n.stake-payout-modal {\n    max-width: 480px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.stake-payout-modal__status {\n    padding: 24px 0;\n    text-align: center;\n    color: #848e9c;\n    font-size: 14px;\n}\n\n.stake-payout-modal__status--error {\n    color: #f6465d;\n}\n\n.stake-payout-modal__summary {\n    max-height: none;\n    margin-bottom: 16px;\n}\n\n.stake-payout-modal__records {\n    margin-bottom: 16px;\n}\n\n.stake-payout-modal__recordsTitle {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1e2329;\n    margin-bottom: 10px;\n}\n\n.stake-payout-modal__empty {\n    padding: 20px 14px;\n    text-align: center;\n    font-size: 13px;\n    color: #848e9c;\n    background: rgb(255 255 255 /60%);\n    border-radius: 8px;\n}\n\n.stake-payout-modal__list {\n    background: rgb(255 255 255 /60%);\n    border-radius: 8px;\n    max-height: 240px;\n    overflow-y: auto;\n}\n\n.stake-payout-modal__record {\n    padding: 12px 14px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.stake-payout-modal__record:last-child {\n    border-bottom: none;\n}\n\n.stake-payout-modal__recordTop {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 6px;\n}\n\n.stake-payout-modal__recordAmount {\n    font-size: 14px;\n    font-weight: 600;\n    color: #03a66d;\n}\n\n.stake-payout-modal__recordType {\n    font-size: 12px;\n    font-weight: 500;\n    color: #1e2329;\n    background: rgb(255 255 255 / 15%);\n    border: 1px solid rgb(234 236 239 / 10%);\n    border-radius: 4px;\n    padding: 2px 8px;\n    white-space: nowrap;\n}\n\n.stake-payout-modal__recordBottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    font-size: 12px;\n    color: #848e9c;\n}\n\n.stake-payout-modal__pagination {\n    margin-top: 0;\n    margin-bottom: 16px;\n}\n\n.stake-payout-modal__actions {\n    margin-top: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media (max-width: 767px) {\n\n\n    .stake-overview-overlay {\n        align-items: flex-end;\n    }\n\n    .redeem-modal-footer .mint-actions {\n        flex-direction: row;\n    }\n\n    .project_card {\n        margin: 20px 0px;\n    }\n\n    .stake-overview-content {\n        max-width: 100%;\n        border-radius: 12px 12px 0 0;\n        max-height: 85vh;\n        overflow-y: auto;\n    }\n\n    .stake-overview-actions {\n        flex-direction: column;\n    }\n}\n\n/* Stake success popup */\n.stake-success-overlay {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.45);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100000001;\n    padding: 16px;\n    animation: fadeInModal 0.2s ease-out;\n}\n\n.stake-success-content {\n    background: #fff;\n    color: #1e2329;\n    width: 100%;\n    max-width: 380px;\n    border-radius: 12px;\n    padding: 28px 24px 24px;\n    text-align: center;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);\n    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.stake-success-icon {\n    font-size: 52px;\n    color: #03a66d;\n    line-height: 1;\n    margin-bottom: 12px;\n}\n\n.stake-success-title {\n    margin: 0 0 10px;\n    font-size: 20px;\n    font-weight: 700;\n    color: #1e2329;\n}\n\n.stake-success-message {\n    margin: 0 0 18px;\n    font-size: 14px;\n    color: #848e9c;\n    line-height: 1.6;\n}\n\n.stake-success-message strong {\n    color: #03a66d;\n    font-weight: 600;\n}\n\n.stake-success-package {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: #fafafa;\n    border-radius: 8px;\n    padding: 12px 14px;\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.stake-success-package__icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.stake-success-package__info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.stake-success-package__name {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1e2329;\n}\n\n.stake-success-package__meta {\n    font-size: 12px;\n    color: #848e9c;\n}\n\n.stake-success-btn {\n    width: 100%;\n}\n\n.stake-overview-row__value--danger {\n    color: #f6465d;\n}\n\n.mint-btn-confirm--danger:not(:disabled) {\n    background-color: #f6465d;\n    color: #fff !important;\n}\n\n.mint-btn-confirm--danger:not(:disabled):hover {\n    background-color: #e03e52;\n}\n\n.cancel-staking-modal {\n    max-width: 480px;\n}\n\n.cancel-staking-body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.cancel-staking-warning {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0;\n    padding: 12px 14px;\n    background: #fff8e6;\n    border-radius: 8px;\n    font-size: 13px;\n    color: #92400e;\n    line-height: 1.5;\n}\n\n.cancel-staking-warning i {\n    font-size: 18px;\n    flex-shrink: 0;\n    line-height: 1;\n}\n\n.cancel-staking-warning span {\n    flex: 1;\n    min-width: 0;\n}\n\n.cancel-staking-optional {\n    font-weight: 400;\n    color: #848e9c;\n    font-size: 12px;\n}\n\n.cancel-staking-reason {\n    width: 100%;\n    min-height: 88px;\n    padding: 12px 14px;\n    border: 1px solid #eaecef;\n    border-radius: 8px;\n    font-family: inherit;\n    font-size: 14px;\n    color: #1e2329;\n    resize: vertical;\n    box-sizing: border-box;\n}\n\n.cancel-staking-reason:focus {\n    outline: none;\n    border-color: #1a1d21;\n}\n\n.stake-overview-body--compact {\n    margin-bottom: 0;\n}\n\n.stake-overview-body--inline {\n    margin-bottom: 20px;\n    text-align: left;\n}\n\n.stake-success-icon--cancel {\n    color: #03a66d;\n}\n\n/* Dark Theme Overrides for Staking Modals */\nbody:not(.light_theme) .mint-modal-overlay,\nbody:not(.light_theme) .intro-modal-overlay,\nbody:not(.light_theme) .stake-overview-overlay,\nbody:not(.light_theme) .stake-success-overlay {\n    background-color: rgba(0, 0, 0, 0.45) !important;\n}\n\nbody:not(.light_theme) .mint-modal-content,\nbody:not(.light_theme) .intro-modal-content,\nbody:not(.light_theme) .stake-overview-content,\nbody:not(.light_theme) .stake-success-content {\n    background-color: #1e232994 !important;\n    background: #1e232994 !important;\n    color: #ffffff !important;\n    border: 1px solid #ffffff12;\n}\n\nbody:not(.light_theme) .mint-info-value,\nbody:not(.light_theme) .mint-amount-val,\nbody:not(.light_theme) .mint-apr-box span:last-child,\nbody:not(.light_theme) .mint-timeline-lbl,\nbody:not(.light_theme) .mint-rules-title,\nbody:not(.light_theme) .stake-overview-row__value,\nbody:not(.light_theme) .stake-success-title,\nbody:not(.light_theme) .stake-success-package__name,\nbody:not(.light_theme) .stake-payout-modal__recordsTitle,\nbody:not(.light_theme) .stake-payout-modal__recordType,\nbody:not(.light_theme) .stake-detail-title-text {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .mint-input-box {\n    border: 1px solid #ffffff12;\n    background-color: #181a20;\n}\n\nbody:not(.light_theme) .mint-input-box input {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .mint-input-box:focus-within {\n    border-color: #5a5a5a;\n}\n\nbody:not(.light_theme) .mint-apr-box,\nbody:not(.light_theme) .mint-daily-return-box,\nbody:not(.light_theme) .service-fee-container,\nbody:not(.light_theme) .stake-overview-body,\nbody:not(.light_theme) .stake-payout-modal__empty,\nbody:not(.light_theme) .stake-payout-modal__list,\nbody:not(.light_theme) .stake-payout-modal__record,\nbody:not(.light_theme) .stake-success-package {\n    background-color: #181a2059 !important;\n    background: #181a2059 !important;\n    border: 1px solid #ffffff12 !important;\n}\n\nbody:not(.light_theme) .service-fee-value {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .tier-item-left {\n    background-color: #181a20 !important;\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .tier-item {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .tier-timeline::before,\nbody:not(.light_theme) .mint-timeline::before {\n    background-color: #ffffff12;\n}\n\nbody:not(.light_theme) .mint-timeline-dot {\n    background-color: #ffffff12;\n}\n\nbody:not(.light_theme) .mint-timeline-dot.active {\n    background-color: #ffffff;\n}\n\nbody:not(.light_theme) .mint-agreement label,\nbody:not(.light_theme) .mint-agreement label a {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .mint-btn-cancel {\n    background-color: #2b3139;\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .mint-btn-confirm:not(:disabled) {\n    background: #8d7650;\n    color: #000;\n}\n\nbody:not(.light_theme) .cancel-staking-warning {\n    background: rgb(255 255 255 / 10%);\n    color: #e7e7e7;\n}\n\nbody:not(.light_theme) .cancel-staking-reason {\n    background: #181a20;\n    color: #ffffff;\n    border: 1px solid #ffffff12;\n}\n\nbody:not(.light_theme) .cancel-staking-reason:focus {\n    border-color: #d1aa67;\n}\n\nbody:not(.light_theme) .stake-overview-row {\n    border-bottom: none;\n}\n\nbody:not(.light_theme) .stake-payout-modal__record {\n    border-bottom: none;\n}\n\nbody:not(.light_theme) .mint-modal-close:hover,\nbody:not(.light_theme) .intro-close-btn:hover {\n    color: #ffffff !important;\n}\n\nbody:not(.light_theme) .mint-title-underline {\n    background-color: #ffffff;\n}\n\n/* Staking Detail Modal Helpers */\n.stake-detail-title-text {\n    font-weight: 700;\n    font-size: 16px;\n    color: #1e2329;\n}\n\nbody:not(.light_theme) .stake-detail-title-text {\n    color: #ffffff;\n}\n\n.stake-detail-subtitle-text {\n    font-weight: 400;\n    color: #848e9c;\n    font-size: 13px;\n    margin-left: 4px;\n}\n\n.stake-detail-desc {\n    font-size: 12px;\n    color: #848e9c;\n    margin-top: 2px;\n}\n\n.stake-detail-body {\n    padding: 4px 0 0;\n}\n\n.stake-detail-badge-row {\n    display: flex;\n    gap: 8px;\n    padding: 14px 0 10px;\n    font-size: 13px;\n    font-weight: 500;\n    color: #848e9c;\n}\n\nbody:not(.light_theme) .stake-detail-badge-row {\n    color: #ffffff;\n}\n\n.stake-overview-body--penalty {\n    background-color: #fff3f3 !important;\n}\n\nbody:not(.light_theme) .stake-overview-body--penalty {\n    background-color: #3b1b1b !important;\n    border: 1px solid #ff4d4d1a !important;\n}\n\n.stake-detail-history-wrap {\n    margin-top: 16px;\n}\n\n.stake-detail-history-row {\n    padding: 10px 14px !important;\n}\n\n/* Plan Modal Specific Styles */\n.mint-modal-content.plan-modal {\n    max-width: 480px;\n}\n\n.mint-plan-modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 10px 0px;\n}\n\n\n.mint-plan-loading,\n.mint-plan-empty {\n    text-align: center;\n    padding: 32px;\n    color: #848e9c;\n}\n\n.mint-plan-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 16px;\n    border-radius: 8px;\n    border: 1px solid #eaecef;\n    cursor: pointer;\n    transition: border-color 0.2s, background-color 0.2s;\n}\n\n.mint-plan-card:hover {\n    border-color: #d1aa67;\n}\n\nbody:not(.light_theme) .mint-plan-card {\n    border-color: rgba(255, 255, 255, 0.08);\n}\n\nbody:not(.light_theme) .mint-plan-card:hover {\n    border-color: #d1aa67;\n    background-color: rgba(255, 255, 255, 0.02);\n}\n\n.mint-plan-card-left {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.mint-plan-card-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n}\n\n.mint-plan-duration {\n    font-weight: 600;\n    font-size: 15px;\n    color: #1e2329;\n}\n\nbody:not(.light_theme) .mint-plan-duration {\n    color: #eaecef;\n}\n\n.mint-plan-limits {\n    font-size: 12px;\n    color: #848e9c;\n}\n\n.mint-plan-apr-val {\n    font-weight: 700;\n    font-size: 16px;\n    color: #03a66d;\n}\n\n.mint-plan-apr-lbl {\n    font-size: 11px;\n    color: #848e9c;\n}\n\n/* Mint Input Addon & Modal helper styling */\n.mint-input-currency {\n    font-weight: 600;\n    font-size: 14px;\n    color: #eaecef;\n}\n\nbody.light_theme .mint-input-currency {\n    color: #1e2329;\n}\n\n.mint-input-separator {\n    width: 1px;\n    height: 14px;\n    background-color: #ffffff24;\n}\n\nbody.light_theme .mint-input-separator {\n    background-color: #eaecef;\n}\n\n.mint-info-item-right {\n    text-align: right;\n}\n\n.mint-error-msg {\n    color: #f6465d;\n    font-size: 12px;\n    margin-top: 6px;\n}\n\n.mint-error-msg-center {\n    font-size: 13px;\n    margin-top: 8px;\n    text-align: center;\n}\n\n.mint-apr-box-col {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n}\n\n.mint-apr-standard-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.mint-apr-value {\n    color: #ffffff;\n    font-weight: 600;\n}\n\nbody.light_theme .mint-apr-value {\n    color: #1e2329;\n}\n\n.mint-bonus-apr-label {\n    color: #848e9c;\n    border-bottom: 1px dotted #848e9c;\n    display: inline-block;\n    width: fit-content;\n    margin-bottom: 8px;\n    font-size: 13px;\n    padding-bottom: 2px;\n}\n\n.mint-arrow-icon {\n    color: #eaecef;\n}\n\nbody.light_theme .mint-arrow-icon {\n    color: #4b4f56;\n}\n\n.mint-daily-return-col {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.mint-daily-return-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.mint-table-empty {\n    text-align: center;\n    padding: 32px;\n}\n\n.mint-cards-wrapper {\n    margin-top: 20px;\n}\n\n.mint-btn-full {\n    width: 100%;\n    padding: 12px;\n}\n\n.mint-cursor-pointer {\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
